<template>
  <el-dialog
    :visible.sync="dialogMsg.dialogBookMagaz"
    width="400"
    :before-close="addBack"
  >
  <div v-if="dialogMsg.activeName=='books'">
    <el-row :gutter="20">
      <el-col :span="7">
        <div class="grid-content bg-purple">
          <el-upload

            :action="uploadUrl"
            class="dialogUpload"
            list-type="picture-card"
            accept=".png,.PNG,.jpg,.JPG,.jpeg"
            :http-request="uploadArticle"
            :show-file-list="false"
            :auto-upload="true"
          >
            <img
              v-if="addMsg.image"
              :src="addMsg.image"
              class="upload-image"
              style="width: 100%;"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload></div>
        </el-col>
      <el-col :span="17">
        <div class="grid-content bg-purple">
          <el-input v-model="addMsg.name" placeholder="请输入中文书名">
          </el-input>
          
        </div>
      </el-col>
      <el-col :span="17">
        <div class="grid-content bg-purple">
          <el-input v-model="addMsg.englishName" placeholder="请输入英文书名">
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="twice-line">
      <el-col :span="10">
        <div class="grid-content bg-purple">
          <el-input v-model="addMsg.author" placeholder="输入作者名称">
          </el-input>
          <!-- <el-input v-model="addMsg.publishTime" placeholder="输入出版日期">
          </el-input> -->
            <el-date-picker
      v-model="addMsg.publishTime"
      type="date"
      placeholder="输入出版日期">
    </el-date-picker>
          <el-input v-model="addMsg.organizer" placeholder="输入出版社">
          </el-input>
        </div>
      </el-col>
      <el-col :span="14"
        ><div class="grid-content bg-purple">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6.6, maxRows: 6.6 }"
            placeholder="输入推荐理由"
            v-model="addMsg.recommendReason"
          >
          </el-input>
        </div>
      </el-col>
    </el-row>
  </div>
  <div v-if="dialogMsg.activeName=='magazines'">
    <el-row :gutter="20">
      <el-col :span="7">
        <div class="grid-content bg-purple">
          <el-upload
            v-if="percentageFile==0"
            :action="uploadUrl"
            class="dialogUpload"
            list-type="picture-card"
            accept=".png,.PNG,.jpg,.JPG,.jpeg"
            :http-request="uploadArticle"
            :show-file-list="false"
            :auto-upload="true"
          >
            <img
              v-if="addMsg.image"
              :src="addMsg.image"
              class="upload-image"
              style="width: 100%;"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="process" v-if="percentageFile!=0">
            <el-progress
              type="circle"
              :width = 100
              :percentage="this.percentageFile"
            ></el-progress>
          </div>
          </div>
        </el-col>
      <el-col :span="17">
        <div class="grid-content bg-purple">
          <el-input v-model="addMsg.name" placeholder="请输入中文杂志名">
          </el-input>
          
        </div>
      </el-col>
      <el-col :span="17">
        <div class="grid-content bg-purple">
          <el-input v-model="addMsg.englishName" placeholder="请输入英文杂志名">
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="twice-line">
      <el-col :span="10">
        <div class="grid-content bg-purple">
          <el-input v-model="addMsg.organizer" placeholder="输入出版单位名称">
          </el-input>
          <el-input v-model="addMsg.author" placeholder="请输入主编姓名">
          </el-input>
          <el-input v-model="addMsg.source" placeholder="输入杂志官网链接">
          </el-input>
        </div>
      </el-col>
      <el-col :span="14"
        ><div class="grid-content bg-purple">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6.6, maxRows: 6.6 }"
            placeholder="输入推荐理由"
            v-model="addMsg.recommendReason"
          >
          </el-input>
        </div>
      </el-col>
    </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="addBack">取 消</el-button>
      <el-button type="primary" v-if="dialogMsg.kind!='update'" @click="addOK">新 增</el-button>
      <el-button type="primary" v-if="dialogMsg.kind=='update'" @click="addOK">修 改</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: { dialogMsg: Object,dialogItem:Object },
  data() {
    return {
      percentageFile:0,
      uploadUrl: "",
      addMsg: { tags:[],}
    };
  },
       watch:{        
        dialogItem(val,oldVal){
            this.addMsg = JSON.parse(JSON.stringify(val))
        },
        immediate: true,
        deep: true
    },
  methods: {
    handleClose() { this.$emit("addBack", false);},
    addBack() {
      this.$emit("addBack", false);
      this.addMsg={tags:[],}
    },
    addOK() {
      
        this.$emit("addOK",this.addMsg)
        this.addMsg={tags:[],}
    },
    uploadArticle(params) {
      // this.$global.uploadImage(this, params).then(res => {
      //   this.$set(this.addMsg,"image",res.split("?")[0])
      // });
      console.dir(params.file.name);
      let config = {
        onUploadProgress: (progressEvent) => {
          process =
            (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
          this.percentageFile = parseInt(process);
        },
      };
      this.$global.uploadImageWithConfig(this, params, config).then((res) => {
        this.$set(this.addMsg,"image",res.url.split("?")[0])
        this.percentageFile=0
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.twice-line {
  margin-top: 40px;
}
.el-col-17 {
  margin-bottom: 18px;
}
.el-col-10{
    .grid-content{
        
        .el-input{
            margin-bottom: 15px;
        }
    }
}
.process {
   width: 120px;
    height: 150px;
    text-align: center;
}
.dialogUpload {
  /deep/ .el-upload {
    width: 120px;
    height: 150px;
  }
  img {
    width: 120px;
    height: 150px;
  }
}
// 让日期选择器恢复默认样式
 .el-date-editor{
  width: 100% ;
}
/deep/ .el-dialog__body{padding: 30px;}
.el-dialog__footer {
    padding: 10px 25% 20px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: center;
      .el-button--default:hover {
        background: $base-color;
        color: $blueBtna;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
    }
  }
  .el-upload--picture-card:hover{
     color: $blueBtna;
     border-color: $blueBtna;
  }

</style>


// WEBPACK FOOTER //
// src/components/admin/exploration/components/DialogBooksMagazines.vue